import Component from 'flarum/common/Component';

/* ================= 诗词（全部主题时显示） =================
   选诗标准：避开教科书篇目，偏冷而精的唐宋名联 + 清词丽句。
   每次进入/刷新页面随机一条（模块加载时抽取一次，SPA 内部导航不变）。 */
const POEMS = [
  { line: '深秋帘幕千家雨，落日楼台一笛风。', dyn: '唐代', who: '杜牧', title: '题宣州开元寺水阁阁下宛溪夹溪居人' },
  { line: '从此无心爱良夜，任他明月下西楼。', dyn: '唐代', who: '李益', title: '写情' },
  { line: '多情只有春庭月，犹为离人照落花。', dyn: '唐代', who: '张泌', title: '寄人' },
  { line: '客散酒醒深夜后，更持红烛赏残花。', dyn: '唐代', who: '李商隐', title: '花下醉' },
  { line: '刘郎已恨蓬山远，更隔蓬山一万重。', dyn: '唐代', who: '李商隐', title: '无题·来是空言去绝踪' },
  { line: '天意怜幽草，人间重晚晴。', dyn: '唐代', who: '李商隐', title: '晚晴' },
  { line: '还似洞庭春水色，晓云将入岳阳天。', dyn: '唐代', who: '温庭筠', title: '咸阳值雨' },
  { line: '数声风笛离亭晚，君向潇湘我向秦。', dyn: '唐代', who: '郑谷', title: '淮上与友人别' },
  { line: '残云归太华，疏雨过中条。', dyn: '唐代', who: '许浑', title: '秋日赴阙题潼关驿楼' },
  { line: '蝴蝶梦中家万里，子规枝上月三更。', dyn: '唐代', who: '崔涂', title: '春夕' },
  { line: '残星几点雁横塞，长笛一声人倚楼。', dyn: '唐代', who: '赵嘏', title: '长安晚秋' },
  { line: '浮云一别后，流水十年间。', dyn: '唐代', who: '韦应物', title: '淮上喜会梁川故人' },
  { line: '闲门向山路，深柳读书堂。', dyn: '唐代', who: '刘昚虚', title: '阙题' },
  { line: '寻章摘句老雕虫，晓月当帘挂玉弓。', dyn: '唐代', who: '李贺', title: '南园十三首·其六' },
  { line: '曲终人不见，江上数峰青。', dyn: '唐代', who: '钱起', title: '省试湘灵鼓瑟' },
  { line: '竹怜新雨后，山爱夕阳时。', dyn: '唐代', who: '钱起', title: '谷口书斋寄杨补阙' },
  { line: '雨中黄叶树，灯下白头人。', dyn: '唐代', who: '司空曙', title: '喜外弟卢纶见宿' },
  { line: '孤灯寒照雨，湿竹暗浮烟。', dyn: '唐代', who: '司空曙', title: '云阳馆与韩绅宿别' },
  { line: '凉月如眉挂柳湾，越中山色镜中看。', dyn: '唐代', who: '戴叔伦', title: '兰溪棹歌' },
  { line: '疑是水仙梳洗处，一螺青黛镜中心。', dyn: '唐代', who: '雍陶', title: '题君山' },
  { line: '世间无限丹青手，一片伤心画不成。', dyn: '唐代', who: '高蟾', title: '金陵晚望' },
  { line: '春水碧于天，画船听雨眠。', dyn: '唐代', who: '韦庄', title: '菩萨蛮·其二' },
  { line: '无情最是台城柳，依旧烟笼十里堤。', dyn: '唐代', who: '韦庄', title: '台城' },
  { line: '垂死病中惊坐起，暗风吹雨入寒窗。', dyn: '唐代', who: '元稹', title: '闻乐天授江州司马' },
  { line: '近种篱边菊，秋来未著花。', dyn: '唐代', who: '皎然', title: '寻陆鸿渐不遇' },
  { line: '玉颜不及寒鸦色，犹带昭阳日影来。', dyn: '唐代', who: '王昌龄', title: '长信秋词五首·其三' },
  { line: '细雨梦回鸡塞远，小楼吹彻玉笙寒。', dyn: '南唐', who: '李璟', title: '摊破浣溪沙' },
  { line: '风乍起，吹皱一池春水。', dyn: '五代', who: '冯延巳', title: '谒金门' },
  { line: '鸿雁在云鱼在水，惆怅此情难寄。', dyn: '宋代', who: '晏殊', title: '清平乐·红笺小字' },
  { line: '落花人独立，微雨燕双飞。', dyn: '宋代', who: '晏几道', title: '临江仙·梦后楼台高锁' },
  { line: '今宵剩把银釭照，犹恐相逢是梦中。', dyn: '宋代', who: '晏几道', title: '鹧鸪天·彩袖殷勤捧玉钟' },
  { line: '自在飞花轻似梦，无边丝雨细如愁。', dyn: '宋代', who: '秦观', title: '浣溪沙·漠漠轻寒上小楼' },
  { line: '一川烟草，满城风絮，梅子黄时雨。', dyn: '宋代', who: '贺铸', title: '青玉案·凌波不过横塘路' },
  { line: '叶上初阳干宿雨，水面清圆，一一风荷举。', dyn: '宋代', who: '周邦彦', title: '苏幕遮·燎沉香' },
  { line: '云破月来花弄影。', dyn: '宋代', who: '张先', title: '天仙子·水调数声持酒听' },
  { line: '中庭月色正清明，无数杨花过无影。', dyn: '宋代', who: '张先', title: '木兰花·乙卯吴兴寒食' },
  { line: '殷勤昨夜三更雨，又得浮生一日凉。', dyn: '宋代', who: '苏轼', title: '鹧鸪天·林断山明竹隐墙' },
  { line: '桃李春风一杯酒，江湖夜雨十年灯。', dyn: '宋代', who: '黄庭坚', title: '寄黄几复' },
  { line: '杏花疏影里，吹笛到天明。', dyn: '宋代', who: '陈与义', title: '临江仙·夜登小阁忆洛中旧游' },
  { line: '小楼一夜听春雨，深巷明朝卖杏花。', dyn: '宋代', who: '陆游', title: '临安春雨初霁' },
  { line: '二十四桥仍在，波心荡、冷月无声。', dyn: '宋代', who: '姜夔', title: '扬州慢·淮左名都' },
  { line: '何处合成愁？离人心上秋。', dyn: '宋代', who: '吴文英', title: '唐多令·惜别' },
  { line: '落絮无声春堕泪，行云有影月含羞。', dyn: '宋代', who: '吴文英', title: '浣溪沙·门隔花深旧梦游' },
  { line: '流光容易把人抛，红了樱桃，绿了芭蕉。', dyn: '宋代', who: '蒋捷', title: '一剪梅·舟过吴江' },
  { line: '疏影横斜水清浅，暗香浮动月黄昏。', dyn: '宋代', who: '林逋', title: '山园小梅' },
  { line: '平芜尽处是春山，行人更在春山外。', dyn: '宋代', who: '欧阳修', title: '踏莎行·候馆梅残' },
  { line: '泪眼问花花不语，乱红飞过秋千去。', dyn: '宋代', who: '欧阳修', title: '蝶恋花·庭院深深深几许' },
  { line: '真珠帘卷玉楼空，天淡银河垂地。', dyn: '宋代', who: '范仲淹', title: '御街行·秋日怀旧' },
  { line: '写不成书，只寄得、相思一点。', dyn: '宋代', who: '张炎', title: '解连环·孤雁' },
  { line: '欲将心事付瑶琴。知音少，弦断有谁听。', dyn: '宋代', who: '岳飞', title: '小重山·昨夜寒蛩不住鸣' },
  { line: '山中何事？松花酿酒，春水煎茶。', dyn: '元代', who: '张可久', title: '人月圆·山中书事' },
  { line: '雨打梨花深闭门，忘了青春，误了青春。', dyn: '明代', who: '唐寅', title: '一剪梅·雨打梨花深闭门' },
  { line: '被酒莫惊春睡重，赌书消得泼茶香。当时只道是寻常。', dyn: '清代', who: '纳兰性德', title: '浣溪沙·谁念西风独自凉' },
  { line: '似此星辰非昨夜，为谁风露立中宵。', dyn: '清代', who: '黄景仁', title: '绮怀十六首·其十五' },
  { line: '一箫一剑平生意，负尽狂名十五年。', dyn: '清代', who: '龚自珍', title: '漫感' },
  { line: '春雨楼头尺八箫，何时归看浙江潮。', dyn: '近代', who: '苏曼殊', title: '本事诗' },
];

/* ================= 二次元语录（galgame 标签下显示） =================
   每次进入/刷新页面随机一条；galgame 0.7 / 动漫·轻小说·漫画 0.3。 */
const QUOTES_GAL = [
  { zh: '试问——你就是我的Master吗？', ja: '問おう。あなたが私のマスターか', who: '阿尔托莉雅《Fate/stay night》' },
  { zh: '吾身为剑所铸。', ja: '体は剣で出来ている。', who: 'Archer《Fate/stay night》' },
  { zh: '这就是，命运石之门的选择。', ja: 'これが、シュタインズゲートの選択だ。', who: '冈部伦太郎《命运石之门》' },
  { zh: '我可是高性能的！', ja: 'わたし、高性能ですから！', who: 'ATRI《ATRI -My Dear Moments-》' },
  { zh: '时间啊，停止吧，你是多么美丽。时间啊，流逝吧，你是多么残酷！', ja: '時よ止まれ、お前は美しい。時よ過ぎゆけ、お前は残酷だ。！', who: 'ATRI《ATRI -My Dear Moments-》' },
  { zh: '人啊，幸福吧！', ja: '人よ、幸福たれ！', who: '水上由岐《素晴らしき日々》' },
  { zh: '没有未来的未来不是我想要的未来。', ja: '未来のない未来なんて、僕はいらない', who: '冈部伦太郎《命运石之门》' },
  { zh: '那双眼睛，是谁的眼睛？', ja: 'その目、だれの目？', who: '《CHAOS;HEAD》' },
  { zh: '无论在哪里，我们的头顶都是同一片天空。', ja: 'どこにいても、私たちの頭上には同じ空が広がっている。', who: '春日野穹《缘之空》' },
  { zh: '能哭的地方，只有洗手间，和爸爸的怀里。', ja: '泣いていい場所は、トイレと、お父さんの胸の中だけ。', who: '冈崎汐《CLANNAD》' },
  { zh: '梦里不觉秋已深，余情岂是为他人。', ja: '夢の中では秋が深いとも気づかず、この想いは他の誰のためでもない。', who: '冬马和纱《白色相簿2》' },
  { zh: '人啊，幸福吧！不沉溺于幸福，也不绝望于世界，只是幸福地活下去。', ja: '人よ、幸福たれ！　幸福に溺れる事なく……この世界に絶望する事なく……ただ幸福に生きよ', who: '水上由岐《素晴日》' },
  { zh: '明明是我先来的啊！', ja: '俺が最初に来たのに！', who: '冬马和纱《白色相簿2》' },
  { zh: '我是主角，你凭什么抢戏？', ja: '俺が主人公だぞ、なんでお前が主役なんだ！', who: '安艺伦也《路人女主》' },
  { zh: 'Happy Birthday to you……Happy Birthday dear 心一。', ja: 'ハッピーバースデー・トゥー・ユー……ハッピーバースデー・ディア・心一', who: '曾根美雪《你和她和她的恋爱》' },
  { zh: '噜噜……噜噜……听到吗？电波，传达到了哦。', ja: 'ルル……ルル……聞こえる？　電波、届いたよ', who: '向日葵《你和她和她的恋爱。》' },
  { zh: '姆啾～', ja: 'むぎゅ～', who: '紬·文德斯《夏日口袋》' },
  { zh: '这个夏天，能不能永远不要结束啊。', ja: 'この夏、ずっと終わらなければいいのに', who: '鹰原羽依里《夏日口袋》' },
  { zh: '唯有那份炫目，未曾忘却。', ja: '眩しさだけは、忘れなかった', who: '《夏日口袋》题眼' },
  { zh: '它若是虚无，虚无本身即是如此；若说有共通之处，那便是众生皆然。', ja: 'それが虚無なら、虚無そのものであればいい。通じ合うとすれば、それはすべての者において', who: '《樱之诗》题诗' },
  { zh: '轻轻晃动的樱之森中，响起了世界的声音。', ja: '揺れる桜の森の中で、世界の音が鳴る', who: '《樱之诗》结尾诗' },
  { zh: '无法飞翔的翅膀，还有意义吗？', ja: '飛べない翼に、意味はあるのでしょうか。', who: '远野美凪《AIR》' },
  { zh: '无法飞翔的翅膀也是有意义的，因为那是曾经翱翔于天空时的珍贵回忆。', ja: '飛べない翼にも意味はあるさ。それは空を飛んでいた日々の、大切な思い出だから。', who: '国崎往人《AIR》' },
  { zh: '不是因为被拯救而相信，是因为相信才被拯救。', ja: '救われたから信じるのではない、信じるからこそ救われるのだ。', who: '柯蕾特《秽翼的尤斯蒂娅》' },
  { zh: '知而无为，就是一种不可否认的罪孽。', ja: '知っていてなにもしないこと、それは否めない罪悪だ。', who: '鲁基乌斯《秽翼的尤斯蒂娅》' },
  { zh: '纯氧对生物有害；毫无保留的真相，只会把人的精神击溃。', ja: '酸素百パーセントは生物に毒だ。飾り気のない真実は、人の精神を打ち砕くだけだ。', who: '虚渊玄《沙耶之歌》' },
  { zh: '约定，是普通人也能使用的言灵。', ja: '約束は、普通人でも使える言霊だ。', who: '《天津罪》' },
  { zh: '晨意微寒秋渐深，侧伴无事俏佳人。', ja: '秋深し、隣はなにも、しない人。', who: '北原春希《白色相簿2》' },
  { zh: '你为什么这么熟练啊！', ja: 'なんでそんなに上手いんだよ！', who: '冬马和纱《白色相簿2》' },
   { zh: '奇迹之所以被称为奇迹，是因为根本就不会发生。', ja: '奇跡と呼ばれるのは、そもそも起こらないからだ。', who: '月宫亚由《Kanon》' },
  { zh: '幸福并不会从天而降，必须靠自己的努力。', ja: '幸せは天から降ってくるものじゃない、自分の力で掴むものだ。', who: '天王寺瑚太朗《Rewrite》' },
  { zh: '若没有在黑暗中行走过，就不会懂得光的意义。', ja: '暗闇を歩いたことがなければ、光の意味など分からない。', who: '神户小鸟《Rewrite》' },
  { zh: '音乐响彻耳畔，不为任何人，只为了正在聆听的你。', ja: '音は耳に響く、誰のためでもなく、それを聴くあなたのために。', who: '间宫皆守《素晴日》' },
  { zh: '这世上无论多么短暂的瞬间，都有意义。', ja: 'この世のどんなに短い瞬間も、意味を持っている。', who: '水上由岐《素晴日》' },
  { zh: '不知者无罪，但是知而无为，就是一种不可否认的罪孽。', ja: '知らぬは罪にあらず、知ってなお為さぬは、否応なしの罪業。', who: '尤斯蒂娅《秽翼的尤斯蒂娅》' },
  { zh: '人活着，就必然伴随着痛苦，但正因如此，才有活下去的价值。', ja: '人は生きる以上、必ず苦しみを伴う、でもだからこそ、生きる価値がある。', who: '尤斯蒂娅《秽翼的尤斯蒂娅》' },
  { zh: '生者，生者，路化冰河，人生没有四季，仅仅只有冬天的荒野。', ja: '生きる者、生きる者、道は氷河と化す、人生に四季はなく、ただ冬の荒野のみ。', who: '浅井花音《G弦上的魔王》' },
  { zh: '就算世界充满了绝望，也一定会有希望存在。', ja: '世界が絶望に満ちていても、必ず希望は存在する。', who: '浅井花音《G弦上的魔王》' },
  { zh: '遇鬼斩鬼，遇佛弑佛，剑胄之理，其在于此。', ja: '鬼に逢えば鬼を斬り、仏に逢えば仏を弑す、剣冑の理、それここに在り。', who: '景明《装甲恶鬼村正》' },
  { zh: '恶鬼并非天生的，而是被人的恶意所孕育出来的。', ja: '悪鬼は生まれつきのものではなく、人の悪意によって生み出される。', who: '景明《装甲恶鬼村正》' },
  { zh: '平凡的天才能展现自己的才能，真正的天才能让人忘却才能。', ja: '凡庸な天才は才能を見せ、真の天才は才能を忘れさせる。', who: '草薙直哉《樱之诗》' },
  { zh: '长夜伴浪破晓梦，梦晓破浪伴夜长。', ja: '長夜浪を伴いて夢を破り曉に至り、夢曉に浪を破りて夜長を伴う。', who: '草薙直哉《樱之诗》' },
  { zh: '艺术不是模仿自然，而是与自然竞争。', ja: '芸術は自然を模倣するものではなく、自然と競うものだ。', who: '蓝《樱之诗》' },
  { zh: '风平浪静的时候已经过去，鸟儿借助风力努力向上飞着，只要鸟儿和风永远永远都是那样的自由。', ja: '風穏やかな日は過ぎ去り、鳥は風を借りて高く飛ぶ、鳥も風も永遠にそのまま自由であれ。', who: '白河萤《秋之回忆2》' },
  { zh: '最后呢，在这片沙漠之中，至少我能知道，还会有一个珍爱这朵花儿的人，有一个人就足够了。', ja: '最後に、この砂漠で、せめてこの花を愛する者が一人いると知っている、一人いれば十分だ。', who: '匂坂郁纪《沙耶之歌》' },
  { zh: '可以和我握一下手吗？除了你以外，就没有其他人可拜托了。', ja: '私と手を握ってくれないか？君以外に頼める人がいないんだ。', who: '匂坂郁纪《沙耶之歌》' },
  { zh: '只需要一个人，在这片荒芜的沙漠中，告诉它：你很美。', ja: 'たった一人だけでも、この荒野で、その花に「美しい」と言ってくれる人がいればいい。', who: '沙耶《沙耶之歌》' },
  { zh: '万物皆流转，即使某处有多少的善恶分踞，今天的太阳依然会从东边升起，犹如车轮一般。', ja: '万物は流転し、どこにどれほど善悪が分かれていても、今日の太陽は東から昇る、車輪のごとく。', who: '莱茵哈特《车轮之国》' },
  { zh: '什么「人生是一连串的选择」，其实是在失败之后人们回首往事时出于后悔而发出的无用感叹。', ja: '「人生は選択の連続だ」などというのは、失敗した後で後悔から吐く役立たずの溜息だ。', who: '曾根美雪《君与彼女与彼女之恋》' },
  { zh: '我的时间静止了，在这个只看得到自己的世界里，我送走了不知多少个季节。', ja: '私の時間は止まった、自分しか見えないこの世界で、何度季節を送ったか分からない。', who: '濑津美《水仙》' },
  { zh: '两人心中仍有期望，和银色的夜晚，只隔着一层玻璃。', ja: '二人の胸にはまだ望みがあり、銀色の夜とはガラス一枚隔てているだけ。', who: '濑津美《水仙》' },
  { zh: '晚安，诗音。', ja: 'おやすみ、詩音。', who: '亮《eden》' },
  { zh: '即使记忆消失，爱意也会留在身体的深处。', ja: '記憶が消えても、愛は体の奥底に残る。', who: '诺艾尔《星之梦》' },
  { zh: '向日葵追寻的不是太阳，而是那份温暖。', ja: 'ひまわりが追うのは太陽ではなく、その温かさだ。', who: '美咲《向日葵教会》' },
  { zh: '善恶相抵。', ja: '善悪相殺。', who: '凑斗景明《装甲恶鬼村正》' },
  { zh: '如果生命的脚印终有一天会被时间的尘埃掩埋，那我们就永远不能停下脚步。', ja: 'いつか足跡が時の塵に埋もれても、だからこそ私たちは歩き続けなければならない。', who: '阿米娅《明日方舟》' },
  { zh: '如果没有人有了解真相的意愿，那就算把真相撒播在街道上，也不会发芽的。', ja: '真実を知ろうとする者がいなければ、街に蒔いた真実も芽を出さない。', who: '凯尔希《明日方舟》' },
  { zh: '去掉所有的符号，我们的生命才有自己的价值。', ja: 'すべての記号を剥ぎ取ったとき、私たちの命にはじめて自分自身の価値が宿る。', who: '凯尔希《明日方舟》' },
  { zh: '如果信使光盯着脚下的路，是会因为看不见落脚点而坠落的。', ja: '使者が足元の道ばかりを見ていたら、踏み出す場所が見えずに墜ちることになる。', who: '安洁莉娜《明日方舟》' },
  { zh: '只要我手握着光辉，只要我还满怀信心，这片大地的苦厄就困不住我。', ja: 'この手に光りがあり、この胸に確かな信がある限り、この大地の苦難など私を囚うことはできない。', who: '玛嘉烈·临光《明日方舟》' },
  { zh: '即使生于黑夜，也要在苦难摇篮里怒号光明。', ja: 'たとえ夜に生まれようとも、苦しみの揺りかごの中で光を叫び上げよ。', who: '《明日方舟》' },
  { zh: '风带来故事的种子，时间使之发芽。', ja: '風は物語の種を運び、時がそれを芽吹かせる。', who: '温迪《原神》' },
  { zh: '浮世景色百千年依旧，人之在世却如白露与泡影。', ja: '浮世の景色は千年も変わらぬもの、されど人の世は白露や泡影のごときもの。', who: '雷电影《原神》' },
  { zh: '我虽无意逐鹿，却知苍生苦楚。', ja: '私は覇を争うつもりはないが、民の苦しみは知っている。', who: '钟离《原神》' },
  { zh: '一切力量皆有其代价，一千种权力伴随着一千种责任。', ja: 'あらゆる力には代償があり、千の権力は千の責任を伴う。', who: '钟离《原神》' },
  { zh: '当你重新踏上旅途之后，一定要记得旅途本身的意义。', ja: 'また旅に出るとき、旅そのものの意味を忘れないでくれ。', who: '温迪《原神》' },
  { zh: '烟花易逝，人情长存。', ja: '花火は散りやすくとも、人の縁は長く残る。', who: '宵宫《原神》' },
  { zh: '欲买桂花同载酒，只可惜故人，何日再见呢。', ja: '桂花を買い、酒を載せて遊びたいが、あの仲間はもういない。いつまた会えるだろう。', who: '钟离《原神》' },
  { zh: '朋友，假使有一日不得不同你相别，你在我的记忆中也会如黄金般闪耀。', ja: 'もし別れねばならぬ日が来ても、君は私の記憶の中で黄金のように輝き続ける。', who: '钟离《原神》' },
  { zh: '所谓开拓，就是沿着前人未尽的道路，走出更遥远的距离。', ja: '開拓とは、先人が果たせなかった道の上を、さらに遠くまで歩くことだ。', who: '姬子《崩坏：星穹铁道》' },
  { zh: '这么大个钻石，送给你啦！！', ja: 'こんなに大きなダイヤモンド、あげるよ！！', who: '黑塔《崩不住了，老铁》' },
  { zh: '迷茫的时候就抬头看看星空吧，我愿在那里，为你照亮整片黑夜。', ja: '迷ったら、星を見上げて。私はあの夜空で、君を照らす灯になろう。', who: '姬子《崩坏：星穹铁道》' },
  { zh: '真正可怕的，并不是这世界夺走多少生命，而是它让多少人对失去生命这件事习以为常。', ja: '恐ろしいのは命が奪われることではない。人が命の喪失に慣れてしまうことだ。', who: '姬子《崩坏：星穹铁道》' },
  { zh: '为了人类，为了未来，为了那一抹尚未熄灭的光。', ja: '人類のために、未来のために、まだ消えぬあの光のために。', who: '琪亚娜《崩坏3》' },
  { zh: '每一个人都有自己想要守护的东西，这和强弱无关。', ja: '誰にも守りたいものがある。それは強さとは関係ない。', who: '八重樱《崩坏3》' },

  
  
    
  
  
];
const QUOTES_ANIME = [
  { zh: '不能逃避。', ja: '逃げちゃダメだ', who: '碇真嗣《新世纪福音战士》' },
  { zh: '一旦放弃，比赛就到此为止了。', ja: 'あきらめたら、そこで試合終了ですよ', who: '安西光义《灌篮高手》' },
  { zh: '我是要成为海贼王的男人！', ja: '海賊王に、俺はなる！', who: '蒙奇·D·路飞《海贼王》' },
  { zh: '人真正死去的时候，是被世人遗忘的时候。', ja: '人はね、忘れ去られた時に、死ぬんだよ', who: '希鲁鲁克《海贼王》' },
  { zh: '我想要的，是真物。', ja: '俺は、本物が欲しい', who: '比企谷八幡《我的青春恋爱物语果然有问题》' },
  { zh: '刺猬的困境——越靠近彼此，就越会刺伤彼此。', ja: 'ハリネズミのジレンマ――近づけば近づくほど、傷つけ合う。', who: '赤木律子《新世纪福音战士》' },
  { zh: '如果这个世界不能满足我，那我就来改变它！', ja: 'この世界が私の思い通りにならないなら、私がこの世界を変えてやる！', who: '凉宫春日《凉宫春日的忧郁》' },
  { zh: '我对普通的人类没有兴趣。', ja: 'ただの人間には興味ありません。', who: '凉宫春日《凉宫春日的忧郁》' },


  { zh: '真是不想承认啊——那所谓的因年轻而犯下的错。', ja: '認めたくないものだな。若さゆえの過ちというものを', who: '夏亚·阿兹纳布尔《机动战士高达》' },
  { zh: '人没有牺牲就什么都得不到；要得到什么，就必须付出同等的代价。这就是等价交换。', ja: '人は何かの犠牲なしに、何も得ることはできない。それが、等価交換だ', who: '爱德华·艾尔利克《钢之炼金术师》' },
  { zh: '一切，都在计划之中。', ja: '計画通り', who: '夜神月《死亡笔记》' },
  { zh: '已经没事了。要问为什么——因为我来了！', ja: 'もう大丈夫。なぜなら、私が来たからだ', who: '欧尔麦特《我的英雄学院》' },
  { zh: '恶·即·斩。', ja: '悪・即・斬', who: '绯村剑心《浪客剑心》' },
  { zh: '哪怕再多一年、再多一日、再多一时也好，我仍想活下去。我深知命如蜉蝣，死亡如影随形。', ja: 'あと一年でも、一日でも、一時間でもいい、生きていたい。命は蜉蝣のように儚く、死はいつもそばにいると分かっているけれど。', who: '岩户铃芽《铃芽之旅》' },
  { zh: '隐约雷鸣，阴霾天空；但盼风雨来，能留你在此。隐约雷鸣，阴霾天空；即使天无雨，我亦留此地。', ja: '鳴る神の 少し響み 雨も降らぬか この君を 留め置かむ 鳴る神の 少し響み 雨も降らず この君を 留め置かむ', who: '《万叶集》/ 雪野百香里《言叶之庭》' },
  { zh: '我们仰望着同一片天空，却看着不同的地方。', ja: '僕たちは同じ空を見上げているのに、見ている場所は違う。', who: '远野贵树《秒速五厘米》' },

  
  { zh: '樱花飘落的速度是秒速五厘米。我要以怎样的速度，才能再次与你相遇？', ja: '桜の花びらの落ちる速度は、秒速5センチメートル。僕はどれくらいの速さで生きれば、もう一度君に会えるんだろう。', who: '远野贵树《秒速五厘米》' },

  { zh: '你指尖跃动的电光，是我此生不灭的信仰。——唯我超电磁炮永世长存。', ja: '君の指先で躍る電光は、私の一生変わらぬ信仰。このレールガンだけが永遠に生きてる！', who: '《某科学的超电磁炮》' },

];

/* —— 每次页面加载各抽一条（刷新即换；SPA 内部导航保持不变） —— */
// 防连击：sessionStorage 记住本标签页上一条，抽中重复则重摇（池子不足2条时不重摇）
function pickAvoidRepeat(pool, field, storeKey) {
  if (!pool || !pool.length) return null;
  if (pool.length < 2) return pool[0];
  let last = null;
  try {
    last = sessionStorage.getItem(storeKey);
  } catch (e) {}
  let pick = pool[Math.floor(Math.random() * pool.length)];
  let tries = 0;
  while (pick[field] === last && tries < 4) {
    pick = pool[Math.floor(Math.random() * pool.length)];
    tries++;
  }
  try {
    sessionStorage.setItem(storeKey, pick[field] || '');
  } catch (e) {}
  return pick;
}

const Q2D_POOL = Math.random() < 0.7 ? QUOTES_GAL : QUOTES_ANIME;
const Q2D_QUOTE = pickAvoidRepeat(Q2D_POOL, 'zh', 'bbsQuoteLast2d');
const POEM_PICK = pickAvoidRepeat(POEMS, 'line', 'bbsQuoteLastPoem');

export default class QuoteBanner extends Component {
  view(vnode) {
    // 整体防护：横幅任何异常都不能影响页面渲染
    try {
      const slug = vnode.attrs.slug;

      if (slug) {
        const tag = app.store.all('tags').find((t) => t.slug() === slug);
        const is2D = !!(tag && /二次元|gal/i.test((tag.name() || '') + ' ' + slug));
        if (!is2D) return null;

        const q = Q2D_QUOTE;
        return m('div.QuoteBanner.QuoteBanner--2d',
          m('div.QuoteBanner-inner',
            m('div.QuoteLine.QuoteLine-zh', '「' + q.zh + '」'),
            m('div.QuoteLine.QuoteLine-ja', '「' + q.ja + '」'),
            m('div.QuoteLine.QuoteLine-who', '—— ' + q.who)
          )
        );
      }

      const p = POEM_PICK;
      return m('div.QuoteBanner.QuoteBanner--poem',
        m('div.QuoteBanner-inner',
          m('div.QuoteLine.QuoteLine-poem', '「' + p.line + '」'),
          m('div.QuoteLine.QuoteLine-attrib', '——【' + p.dyn + '】' + p.who + '《' + p.title + '》')
        )
      );
    } catch (e) {
      return null;
    }
  }
}
